/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Name of the primary outlet.
 * @type {string}
 *
 * @experimental
 */
export const PRIMARY_OUTLET = 'PRIMARY_OUTLET';

/**
 * A collection of parameters.
 *
 * @experimental
 */
export type Params = {
  [key: string]: any
};

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
